import { Checkbox } from '@/components/ui/checkbox';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Textarea } from '@/components/ui/textarea';
import type React from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const AdditionalDataForm: React.FC<{
  form: UseFormReturn<any, any, undefined>;
}> = ({ form }) => {
  const { t } = useTranslation();

  const additionalDataErrors = form.formState.errors.additionalData as any;

  return (
    <div className="grid grid-cols-1 gap-6">
      <FormField
        control={form.control}
        name="additionalData.illness"
        render={({ field }) => {
          return (
            <FormItem>
              <div className="flex flex-row items-end gap-5">
                <FormLabel>
                  {t('activity.formEdit.additionalData.illness')}
                </FormLabel>
                <FormControl>
                  <RadioGroup
                    onValueChange={(value) =>
                      field.onChange({
                        ...field.value,
                        value: value === 'yes'
                      })
                    }
                    defaultValue={field?.value?.value ? 'yes' : 'no'}
                    className="flex items-center mt-0 space-x-2"
                  >
                    <FormItem className="flex items-center space-x-1 space-y-0">
                      <FormControl>
                        <RadioGroupItem value="yes" />
                      </FormControl>
                      <FormLabel className="font-normal">
                        {t('common.yes')}
                      </FormLabel>
                    </FormItem>
                    <FormItem className="flex items-center space-x-1 space-y-0">
                      <FormControl>
                        <RadioGroupItem value="no" />
                      </FormControl>
                      <FormLabel className="font-normal">
                        {t('common.no')}
                      </FormLabel>
                    </FormItem>
                  </RadioGroup>
                </FormControl>
              </div>

              {field?.value?.value && (
                <div className="px-2 py-1">
                  <Textarea
                    {...field}
                    onChange={(e) =>
                      field.onChange({
                        ...field.value,
                        answer: e.target.value
                      })
                    }
                    value={field?.value?.answer ?? ''}
                  />
                  <div>
                    {additionalDataErrors?.illness?.answer && (
                      <div className="mt-2 text-sm text-red-500">
                        {t(additionalDataErrors.illness.answer.message)}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </FormItem>
          );
        }}
      />

      <FormField
        control={form.control}
        name="additionalData.acceptDataPrivacy"
        render={({ field }) => (
          <FormItem>
            <div className="flex flex-start">
              <FormControl>
                <Checkbox
                  id="isAcceptDataPrivacy"
                  checked={field.value}
                  onCheckedChange={() => field.onChange(!field.value)}
                />
              </FormControl>
              <FormLabel htmlFor="isAcceptDataPrivacy" className="ml-2">
                {t('activity.formEdit.additionalData.acceptDataPrivacy')}
              </FormLabel>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="additionalData.acceptTakePhotos"
        render={({ field }) => (
          <FormItem>
            <div className="flex flex-start">
              <FormControl>
                <Checkbox
                  id="isAcceptTakePhotos"
                  checked={field.value}
                  onCheckedChange={() => field.onChange(!field.value)}
                />
              </FormControl>
              <FormLabel htmlFor="isAcceptTakePhotos" className="ml-2">
                {t('activity.formEdit.additionalData.acceptTakePhotos')}
              </FormLabel>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="additionalData.authOfferProducts"
        render={({ field }) => (
          <FormItem>
            <div className="flex flex-start">
              <FormControl>
                <Checkbox
                  id="isAuthOfferProducts"
                  checked={field.value}
                  onCheckedChange={() => field.onChange(!field.value)}
                />
              </FormControl>
              <FormLabel htmlFor="isAuthOfferProducts" className="ml-2">
                {t('activity.formEdit.additionalData.authOfferProducts')}
              </FormLabel>
            </div>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default AdditionalDataForm;
